import { render } from "./sidebar-change-password.vue?vue&type=template&id=bd686f82"
import script from "./sidebar-change-password.vue?vue&type=script&lang=js"
export * from "./sidebar-change-password.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__